/* eslint-disable no-param-reassign */
import { createAsyncThunk } from '@reduxjs/toolkit';

import { getListingVariants } from './getListingVariants';
import { getListingChannelId } from './helpers/channelHelpers';
import { findListingEntity } from './helpers/entityReadHelpers';
import { upsertListing } from './helpers/entityAdapter';
import { setActiveTabByProductChannel } from './helpers/uiAdapter';
import { showChannelGoneToastFromItems } from './helpers/showChannelProductGoneToast';

export const getListings = createAsyncThunk(
  'products/getListings',
  async ({ masterProductId }, { dispatch, extra: { Logger, Toast, sdk } }) => {
    try {
      const { data } = await sdk.products.getListings({ masterProductId });

      showChannelGoneToastFromItems({ Toast, items: data });

      if (data?.length) {
        await Promise.all(data.map((listing) => dispatch(getListingVariants({
          masterProductId,
          channelId: getListingChannelId(listing),
          listingProductId: listing._id,
        }))));
      }

      return data;
    } catch (error) {
      Logger.log('UI', 'ToastProductGetFailed');
      throw error;
    }
  },
);

export const reducer = (builder) => {
  builder
    .addCase(getListings.pending, (state) => {
      state.isBusy = true;
      state.error = null;
    })
    .addCase(getListings.fulfilled, (state, { payload: listings, meta }) => {
      state.isBusy = false;

      if (!listings?.length) return;

      const { masterProductId } = meta.arg;

      listings.forEach((listing) => {
        const channelId = getListingChannelId(listing);
        if (!channelId) return;

        const existingListing = findListingEntity(state, { masterProductId, channelId });
        const existingAssets = state.entities?.assets?.listingAssets?.[listing._id];
        const activeTab = state.ui?.activeTabByProductChannel?.[masterProductId]?.[channelId]
          || existingListing?.listingStatus
          || listing.listingStatus;

        // Drop ephemeral API-only flag — toast already handled in the thunk.
        const listingProduct = { ...listing };
        delete listingProduct.channelProductGone;
        if (existingAssets !== undefined) {
          listingProduct.assets = existingAssets;
        }

        setActiveTabByProductChannel(state, masterProductId, channelId, activeTab);

        upsertListing(state, {
          ...listingProduct,
          masterProductId,
        });
      });
    })
    .addCase(getListings.rejected, (state, { error }) => {
      state.isBusy = false;
      state.error = error;
    });
};
